import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface SidebarSkeletonProps {
  count?: number;
}

export const SidebarSkeleton: React.FC<SidebarSkeletonProps> = ({ count = 5 }) => {
  return (
    <SkeletonTheme baseColor="#2c3034" highlightColor="#383c40">
      <div style={{ padding: "10px" }}>
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} style={{ marginBottom: "15px" }}>
            <Skeleton height={20} width="80%" style={{ marginBottom: "5px" }} />
            <Skeleton height={15} width="60%" />
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

interface FormSkeletonProps {
  rows?: number;
}

export const FormSkeleton: React.FC<FormSkeletonProps> = ({ rows = 4 }) => {
  return (
    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f0f0f0">
      <div style={{ padding: "20px" }}>
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} style={{ marginBottom: "20px" }}>
            <Skeleton height={20} width="30%" style={{ marginBottom: "8px" }} />
            <Skeleton height={40} />
          </div>
        ))}
        <div style={{ marginTop: "30px" }}>
          <Skeleton height={45} width={120} />
        </div>
      </div>
    </SkeletonTheme>
  );
};

interface AccordionSkeletonProps {
  sections?: number;
}

export const AccordionSkeleton: React.FC<AccordionSkeletonProps> = ({ sections = 3 }) => {
  return (
    <SkeletonTheme baseColor="#2c3034" highlightColor="#383c40">
      <div style={{ padding: "10px" }}>
        {Array.from({ length: sections }).map((_, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            <Skeleton height={40} style={{ marginBottom: "5px" }} />
            <div style={{ paddingLeft: "15px" }}>
              <Skeleton height={25} count={3} style={{ marginBottom: "5px" }} />
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 5, columns = 4 }) => {
  return (
    <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f0f0f0">
      <div style={{ padding: "10px" }}>
        <Skeleton height={35} style={{ marginBottom: "10px" }} />
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} style={{ display: "flex", gap: "10px", marginBottom: "8px" }}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Skeleton key={colIndex} height={30} style={{ flex: 1 }} />
            ))}
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
};
